import { CheckBoxOutlineBlankOutlined } from "@mui/icons-material"
import CheckBoxIcon from "@mui/icons-material/CheckBox"
import { FormHelperText } from "@mui/material"
import { Field, useFormikContext } from "formik"
import { CheckboxWithLabel } from "formik-mui"
import React from "react"
import styled from "styled-components"

const StyledContainer = styled.div`
  display: flex;

  .MuiFormControlLabel-label {
    text-align: start !important;
  }
  .Mui-focusVisible {
    border: 2px dashed white;
    outline: 3px dashed #0e3487;
    outline-offset: 2px;
  }
`
const StyledCheckboxWithLabel = styled(CheckboxWithLabel)`
  padding: 0;
  margin-left: 7px;
`

const StyledError = styled(FormHelperText)`
  bottom: -0.5em;
  right: 0px;
  text-align: start !important;
  font-size: 12px !important;
`
export interface FormikCheckboxFieldProps {
  name: string
  label?: React.ReactNode
  required?: boolean
  inputRef?: React.RefObject<HTMLButtonElement>
  children?: React.ReactNode
  normalIcon?: JSX.Element
  checkedIcon?: JSX.Element
  labelText?: string
}

const FormikCheckbox = ({
  name,
  label,
  required,
  inputRef,
  children,
  normalIcon,
  checkedIcon,
  labelText,
  ...props
}: FormikCheckboxFieldProps) => {
  const { errors, touched } = useFormikContext<{ [field: string]: boolean }>()
  return (
    <div>
      <StyledContainer>
        <Field
          component={StyledCheckboxWithLabel}
          type="checkbox"
          required={required}
          icon={
            normalIcon ? (
              normalIcon
            ) : (
              <CheckBoxOutlineBlankOutlined fontSize="small" color="inherit" />
            )
          }
          checkedIcon={
            checkedIcon ? (
              checkedIcon
            ) : (
              <CheckBoxIcon fontSize="small" color="inherit" />
            )
          }
          name={name}
          Label={{ label, style: { marginLeft: 0, alignItems: "center" } }}
          inputRef={inputRef}
          inputProps={{
            "aria-describedby": `${name}-helper-text`,
            "aria-label": labelText,
          }}
          {...props}
        />
        {children}
      </StyledContainer>
      {errors[name] && touched[name] && (
        <StyledError id={`${name}-helper-text`} error>
          {errors[name]}
        </StyledError>
      )}
    </div>
  )
}

export default FormikCheckbox
